import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        const fallbackPath = user.role === "LIVREUR"
            ? "/livreur"
            : user.role === "PRODUCTEUR"
                ? "/robot-production"
                : "/";
        return <Navigate to={fallbackPath} replace />;
    }

    return children;
}
